import { render } from "./ObbHome.vue?vue&type=template&id=a78c802e&scoped=true&ts=true"
import script from "./ObbHome.vue?vue&type=script&lang=ts"
export * from "./ObbHome.vue?vue&type=script&lang=ts"

import "./ObbHome.vue?vue&type=style&index=0&id=a78c802e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78c802e"]])

export default __exports__